import React, { useEffect, useRef, useState } from 'react'
import './Newregi.css';
import axios from 'axios';
import gallary from "../../imgs/gallary.png";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Newregi = () => {
  const [input, setInput] = useState({ vtype: "", dob: "", age: "", mobno: "", name: "", amobno: "", btime: "", type: "", dist: "", height: "", bgrp: "", mangal: "", state: "", vrn: "", apeksha: "", fname: "", mname: "", bro: "", sis: "", pahune: "", ajol: "", cjob: "", cjobdetails: "", income: "", quli: "", qulidetails: "", address: "", navras: "", naksh: "", gan: "", nadi: "", gotra: "", kdvt: "", devak: "", photo1: "", photo1URL: "", photo2: "", photo2URL: "", photo3: "", photo3URL: "", photo4: "", photo4URL: "", jat: "", upjat: "" });
  const [file, setFile] = useState([]);
  const [newedit, setNewedit] = useState("new");
  const [dist, setDist] = useState([]);
  const [cast, setCast] = useState([]);
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const fileInputRef4 = useRef(null);

  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  const [inputimg, setInputimg] = useState({
    imageURL: null,
  });
  const notify = (msg) => toast(msg);


  useEffect(() => {
    if (localStorage.getItem("sredit") !== "") {
      setNewedit("edit");
      let rawData = {
        sr: localStorage.getItem("sredit"),
      }
      rawData = JSON.stringify(rawData)
      let formData = new FormData()
      formData.append('data', rawData)

      axios.post('https://softtesting.in/php/cust/getprofileweb.php', formData, {
        'Content-Type': 'multipart/form-data',

      }).then(function sample(response) {

        console.log(response.data);
        response.data.map((user, index) => (
          setInput({ vtype: user.vtype, dob: convertDateFormat(user.bdate), age: user.age, mobno: user.mobno, name: user.name, amobno: user.amobno, btime: user.vel, type: user.type, dist: user.dist, height: user.height, bgrp: user.bgrp, mangal: user.mangal, state: "Maharashtra", vrn: user.vrn, apeksha: user.stavar, fname: user.fname, mname: user.mname, bro: user.bro, sis: user.sis, pahune: user.pahune, ajol: user.ajol, cjob: user.cjob, cjobdetails: user.cjobdetails, income: user.kmai, quli: user.quli, qulidetails: user.qulidetails, address: user.address, navras: user.navras, naksh: user.naksh, gan: user.gan, nadi: user.nadi, gotra: user.gotra, kdvt: user.kdvt, devak: user.devak, photo1: "", photo1URL: `https://softtesting.in/photo/${localStorage.getItem("sredit")}.jpg`, photo2: "", photo2URL: `https://softtesting.in/photo2/${localStorage.getItem("sredit")}.jpg`, photo3: "", photo3URL: `https://softtesting.in/photo3/${localStorage.getItem("sredit")}.jpg`, photo4: "", photo4URL: `https://softtesting.in/bphoto/${localStorage.getItem("sredit")}.jpg`, jat: user.jat, upjat: user.upjat })

        )
        )
      }).catch(err => {
        console.log(err);
      });
    }
  }, [])



  const handleChange = (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;

    if (name === 'dob') {
      // Calculate age based on birth date
      const birthDate = new Date(valuecurrent);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();

      // Update the state with the calculated age
      setInput((prevState) => ({
        ...prevState,
        [name]: valuecurrent,
        age: age.toString(), // Convert age to string
      }));
    }
    else {
      setInput(value => ({ ...value, [name]: valuecurrent }))
    }
  }

  const quit = ()=>{
    localStorage.setItem("sredit","");
    setNewedit("new");
    navigate("/brmain");
  }

  const uploadProfile = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append('sname', input.name);
    formData.append('address', input.address);
    formData.append('mobno', input.mobno);
    formData.append('quli', input.quli);
    formData.append('jat', input.jat);
    formData.append('upjat', input.upjat);
    formData.append('type', input.type);
    formData.append('apeksha', input.apeksha);
    formData.append('fname', input.fname);
    formData.append('mname', input.mname);
    formData.append('ajol', input.ajol);
    formData.append('pahune', input.pahune);
    formData.append('qulidetails', input.qulidetails);
    formData.append('cjob', input.cjob);
    formData.append('vrn', input.vrn);
    formData.append('vtype', input.vtype);
    formData.append('bdate', formatDate(input.dob));
    formData.append('age', input.age);
    formData.append('income', input.income);
    formData.append('height', input.height);
    formData.append('vel', input.btime);
    formData.append('cjobdetail', input.cjobdetails);
    formData.append('bro', input.bro);
    formData.append('sis', input.sis);
    formData.append('stavar', input.stavar);
    formData.append('mangal', input.mangal);
    formData.append('navras', input.navras);
    formData.append('naksh', input.naksh);
    formData.append('nadi', input.nadi);
    formData.append('gan', input.gan);
    formData.append('gotra', input.gotra);
    formData.append('kdvt', input.kdvt);
    formData.append('devak', input.devak);
    formData.append('mangal', input.mangal);
    formData.append('bgrp', input.bgrp);
    formData.append('upjat', input.upjat);
    formData.append('amobno', input.amobno);
    formData.append('branchcode', localStorage.getItem("brno"));
    formData.append('newedit', newedit);
    formData.append('dist', input.dist);
    formData.append('password', "-");
    formData.append('image', input.photo1);
    formData.append('image2', input.photo2);
    formData.append('image3', input.photo3);
    formData.append('image4', input.photo4);
    formData.append('inid', input.inid);
    formData.append('atoken', input.atoken);
    formData.append('message', input.message);
    formData.append('sredit', localStorage.getItem("sredit"));


    setLoading(true);
    axios.post('https://softtesting.in/staff/php/staff/createprofileweb.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        // Handle the response from the server
        if (!isNaN(response.data)) {
          notify("प्रोफाईल अपलोड यशस्वी झाले!");
          setInput({ vtype: "", dob: "", age: "", mobno: "", name: "", amobno: "", btime: "", type: "", dist: "", height: "", bgrp: "", mangal: "", state: "", vrn: "", apeksha: "", fname: "", mname: "", bro: "", sis: "", pahune: "", ajol: "", cjob: "", cjobdetails: "", income: "", quli: "", qulidetails: "", address: "", navras: "", naksh: "", gan: "", nadi: "", gotra: "", kdvt: "", devak: "", photo1: "", photo1URL: "", photo2: "", photo2URL: "", photo3: "", photo3URL: "", photo4: "", photo4URL: "" });
        }
        else{
          notify(response.data);
          console.log(response.data);
        }
      })
      .catch(error => {
        // Handle any errors
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1; // Add 1 because months are zero-indexed
    const year = date.getFullYear();

    // Pad single digits with a leading zero
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}/${formattedMonth}/${year}`;
  }

  function convertDateFormat(dateString) {
    const parts = dateString.split('/');
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];

    return `${year}-${month}-${day}`;
  }

  const handleImageClick = (event) => {
    const name = event.target.name;
    if (name === "photo1") {
      fileInputRef1.current.click();
    }
    else if (name === "photo2") {
      fileInputRef2.current.click();
    }
    else if (name === "photo3") {
      fileInputRef3.current.click();
    }
    else if (name === "photo4") {
      fileInputRef4.current.click();
    }
  };



  const getdist = () => {
    let rawData = {
      state: "Maharashtra",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getdistweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDist(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getjat = () => {
    let rawData = {
      state: "Maharashtra",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://viivah.com/php/cust/getcastweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setCast(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const handleChangefile = (event) => {
    const name = event.target.name;

    let valuecurrent = event.target.files[0];
    setFile(value => ({ ...value, [name]: valuecurrent }));
  }

  const handleImageUpload = (event, inputname) => {
    const fileimg = event.target.files[0].name;
    const file = event.target.files[0];

    if (inputname === "photo1in") {
      setInput((prevState) => ({
        ...prevState,
        photo1: file,
        photo1URL: URL.createObjectURL(file)
      }));
    }
    else if (inputname === "photo2in") {
      setInput((prevState) => ({
        ...prevState,
        photo2: file,
        photo2URL: URL.createObjectURL(file)
      }));
    }
    else if (inputname === "photo3in") {
      setInput((prevState) => ({
        ...prevState,
        photo3: file,
        photo3URL: URL.createObjectURL(file)
      }));
    }
    else if (inputname === "photo4in") {
      setInput((prevState) => ({
        ...prevState,
        photo4: file,
        photo4URL: URL.createObjectURL(file)
      }));
    }


  };

  function handleEnterKey(event, currentIndex) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const nextIndex = currentIndex + 1;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  }


  return (
    <div className='regimain'>
      <div className="regimainback">
        <span className="regularboldcolor">प्राथमिक माहिती</span>
        <div className="cardregi">
          <div className='formclass'>
            <div className="rowregi">
              <div className="inputgroup">
                <label htmlFor="vtype" className="form-label">वधू/वर प्रकार</label>
                <input onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} list="encodings" autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="vtype" name="vtype" value={input.vtype} onChange={handleChange} placeholder="वधू/वर प्रकार निवडा" ></input>
                <datalist id="encodings">
                  <option key={1} value={"वर"}>वर</option>
                  <option key={2} value={"वधू"}>वधू</option>
                </datalist>
              </div>

              <div className="inputgroup">
                <label htmlFor="dob" className="form-label">जन्मदिनांक</label>
                <input onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="date" className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} autoComplete='off' id="dob" name="dob" value={input.dob} onChange={handleChange} ></input>


              </div>

              <div className="inputgroup">
                <label htmlFor="age" className="form-label">वय</label>
                <input onKeyDown={e => handleEnterKey(e, 2)} ref={ref => (inputRefs.current[2] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="age" name="age" value={input.age} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="mobno" className="form-label">मोबाईल</label>
                <input onKeyDown={e => handleEnterKey(e, 3)} ref={ref => (inputRefs.current[3] = ref)} autoComplete='off' maxLength={11} className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="mobno" name="mobno" value={input.mobno} onChange={handleChange}></input>

              </div>
            </div>
          </div>
        </div>
        <span className="regularboldcolor">स्वताबद्दल माहिती</span>
        <div className="cardregi">
          <div className='formclass'>
            <div className="rowregi">
              <div className="inputgroup">
                <label htmlFor="vtype" className="form-label">नाव</label>
                <input onKeyDown={e => handleEnterKey(e, 4)} ref={ref => (inputRefs.current[4] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="name" name="name" value={input.name} onChange={handleChange}  ></input>
              </div>

              <div className="inputgroup">
                <label htmlFor="amobno" className="form-label">इतर मोबाईल</label>
                <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} autoComplete='off' id="amobno" name="amobno" value={input.amobno} onChange={handleChange} ></input>


              </div>

              <div className="inputgroup">
                <label htmlFor="btime" className="form-label">जन्म वेळ</label>
                <input onKeyDown={e => handleEnterKey(e, 6)} ref={ref => (inputRefs.current[6] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="btime" name="btime" value={input.btime} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="type" className="form-label">लग्न प्रकार</label>
                <input onKeyDown={e => handleEnterKey(e, 7)} ref={ref => (inputRefs.current[7] = ref)} list="typelist" autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="type" name="type" value={input.type} onChange={handleChange}></input>
                <datalist id="typelist">
                  <option key={0} value={"प्रथम"}>प्रथम</option>
                  <option key={1} value={"द्वितीय"}>द्वितीय</option>
                </datalist>
              </div>
            </div>

            <div className="rowregi">
              <div className="inputgroup">
                <label htmlFor="dist" className="form-label">जिल्हा</label>
                <input onKeyDown={e => handleEnterKey(e, 8)} ref={ref => (inputRefs.current[8] = ref)} list="distlist" autoComplete='off'className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="dist" name="dist" value={input.dist} onChange={handleChange} onFocus={getdist} ></input>
                <datalist id="distlist">
                  {dist.map((opt, index) =>
                    <option key={index} value={opt.district}>{opt.district}</option>
                  )}
                </datalist>
              </div>

              <div className="inputgroup">
                <label htmlFor="height" className="form-label">उंची</label>
                <input onKeyDown={e => handleEnterKey(e, 9)} ref={ref => (inputRefs.current[9] = ref)} list="heightlist" className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} autoComplete='off' id="height" name="height" value={input.height} onChange={handleChange} ></input>
                <datalist id="heightlist">
                  <option key={0} value={"4.5"}>4.5</option>
                  <option key={1} value={"4.6"}>4.6</option>
                  <option key={2} value={"4.7"}>4.7</option>
                  <option key={3} value={"4.8"}>4.8</option>
                  <option key={4} value={"4.9"}>4.9</option>
                  <option key={5} value={"4.10"}>4.10</option>
                  <option key={6} value={"4.11"}>4.11</option>
                  <option key={7} value={"5.0"}>5.0</option>
                  <option key={8} value={"5.1"}>5.1</option>
                  <option key={9} value={"5.2"}>5.2</option>
                  <option key={10} value={"5.3"}>5.3</option>
                  <option key={11} value={"5.4"}>5.4</option>
                  <option key={12} value={"5.5"}>5.5</option>
                  <option key={13} value={"5.6"}>5.6</option>
                  <option key={14} value={"5.7"}>5.7</option>
                  <option key={15} value={"5.8"}>5.8</option>
                  <option key={16} value={"5.9"}>5.9</option>
                  <option key={17} value={"5.10"}>5.10</option>
                  <option key={18} value={"5.11"}>5.11</option>
                  <option key={19} value={"6.0"}>6.0</option>
                  <option key={20} value={"6.1"}>6.1</option>
                  <option key={21} value={"6.2"}>6.2</option>
                  <option key={22} value={"6.3"}>6.3</option>
                  <option key={23} value={"6.4"}>6.4</option>
                  <option key={24} value={"6.5"}>6.5</option>

                </datalist>

              </div>

              <div className="inputgroup">
                <label htmlFor="bgrp" className="form-label">रक्तगट</label>
                <input onKeyDown={e => handleEnterKey(e, 10)} ref={ref => (inputRefs.current[10] = ref)} list="bgrplist" autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="bgrp" name="bgrp" value={input.bgrp} onChange={handleChange} ></input>
                <datalist id="bgrplist">
                  <option key={0} value={"A+"}>A+</option>
                  <option key={1} value={"A-"}>A-</option>
                  <option key={2} value={"B+"}>B+</option>
                  <option key={2} value={"B-"}>B-</option>
                  <option key={2} value={"AB+"}>AB+</option>
                  <option key={2} value={"AB-"}>AB-</option>
                  <option key={2} value={"O+"}>O+</option>
                  <option key={2} value={"O-"}>O-</option>
                  <option key={2} value={"उपलब्ध नाही"}>उपलब्ध नाही</option>

                </datalist>
              </div>

              <div className="inputgroup">
                <label htmlFor="mangal" className="form-label">मंगळ माहिती</label>
                <input onKeyDown={e => handleEnterKey(e, 11)} ref={ref => (inputRefs.current[11] = ref)} list="mangalist" autoComplete='off' maxLength={11} className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="mangal" name="mangal" value={input.mangal} onChange={handleChange}></input>
                <datalist id="mangalist">
                  <option key={0} value={"कडक"}>कडक</option>
                  <option key={1} value={"सौम्य"}>सौम्य</option>
                  <option key={2} value={"नाही"}>नाही</option>
                </datalist>
              </div>
            </div>

            <div className="rowregi">
              <div className="inputgroup">
                <label htmlFor="state" className="form-label">राज्य</label>
                <input onKeyDown={e => handleEnterKey(e, 12)} ref={ref => (inputRefs.current[12] = ref)} list="statelist" autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="state" name="state" value={input.state} onChange={handleChange}  ></input>
                <datalist id="statelist">
                  <option key={0} value={"Maharashtra"}>Maharashtra</option>

                </datalist>
              </div>

              <div className="inputgroup">
                <label htmlFor="vrn" className="form-label">वर्ण</label>
                <input onKeyDown={e => handleEnterKey(e, 13)} ref={ref => (inputRefs.current[13] = ref)} list="vrnlist" className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} autoComplete='off' id="vrn" name="vrn" value={input.vrn} onChange={handleChange} ></input>
                <datalist id="vrnlist">
                  <option key={0} value={"गोरा"}>गोरा</option>
                  <option key={1} value={"गोरापान"}>गोरापान</option>
                  <option key={2} value={"गव्हाळ"}>गव्हाळ</option>
                  <option key={3} value={"निम गोरा"}>निम गोरा</option>
                  <option key={4} value={"सावळा"}>सावळा</option>
                  <option key={5} value={"कृष्णवर्णीय"}>कृष्णवर्णीय</option>

                </datalist>

              </div>

              <div className="inputgroup">
                <label htmlFor="apeksha" className="form-label">अपेक्षा / स्थावर</label>
                <input onKeyDown={e => handleEnterKey(e, 14)} ref={ref => (inputRefs.current[14] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"}id="apeksha" name="apeksha" value={input.apeksha} onChange={handleChange} ></input>

              </div>
            </div>
          </div>
        </div>

        <span className="regularboldcolor">कौटुंबिक माहिती</span>
        <div className="cardregi">
          <div className='formclass'>
            <div className="rowregi">
              <div className="inputgroup">
                <label htmlFor="jat" className="form-label">जात/समाज</label>
                <input onKeyDown={e => handleEnterKey(e, 15)} ref={ref => (inputRefs.current[15] = ref)} list="jatlist" autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="jat" name="jat" value={input.jat} onChange={handleChange} onFocus={getjat}  ></input>
                <datalist id="jatlist">
                  {cast.map((opt, index) =>
                    <option key={index} value={opt.castname}>{opt.castname}</option>
                  )}
                </datalist>
              </div>

              <div className="inputgroup">
                <label htmlFor="upjat" className="form-label">उपजात</label>
                <input onKeyDown={e => handleEnterKey(e, 16)} ref={ref => (inputRefs.current[16] = ref)} className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} autoComplete='off' id="upjat" name="upjat" value={input.upjat} onChange={handleChange} ></input>
              </div>

              <div className="inputgroup">
                <label htmlFor="fname" className="form-label">वडिलांचे नाव</label>
                <input onKeyDown={e => handleEnterKey(e, 17)} ref={ref => (inputRefs.current[17] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="fname" name="fname" value={input.fname} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="mname" className="form-label">आईचे नाव</label>
                <input onKeyDown={e => handleEnterKey(e, 18)} ref={ref => (inputRefs.current[18] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="mname" name="mname" value={input.mname} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="bro" className="form-label">भाऊ</label>
                <input onKeyDown={e => handleEnterKey(e, 19)} ref={ref => (inputRefs.current[19] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="bro" name="bro" value={input.bro} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="sis" className="form-label">बहिण</label>
                <input onKeyDown={e => handleEnterKey(e, 20)} ref={ref => (inputRefs.current[20] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="sis" name="sis" value={input.sis} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="pahune" className="form-label">पाहुणे</label>
                <input onKeyDown={e => handleEnterKey(e, 21)} ref={ref => (inputRefs.current[21] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="pahune" name="pahune" value={input.pahune} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="ajol" className="form-label">आजोळ</label>
                <input onKeyDown={e => handleEnterKey(e, 22)} ref={ref => (inputRefs.current[22] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="ajol" name="ajol" value={input.ajol} onChange={handleChange} ></input>

              </div>


            </div>
          </div>
        </div>

        <span className="regularboldcolor">शैक्षणिक व काम माहिती</span>
        <div className="cardregi">
          <div className='formclass'>
            <div className="rowregi">
              <div className="inputgroup">
                <label htmlFor="cjob" className="form-label">सध्याचे काम</label>
                <input onKeyDown={e => handleEnterKey(e, 23)} ref={ref => (inputRefs.current[23] = ref)} list="cjoblist" autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="cjob" name="cjob" value={input.cjob} onChange={handleChange} ></input>
                <datalist id="cjoblist">
                  <option key={0} value={"नोकरी"}>नोकरी</option>
                  <option key={1} value={"व्यवसाय"}>व्यवसाय</option>
                  <option key={2} value={"शेती"}>शेती</option>
                  <option key={3} value={"शिक्षण"}>शिक्षण</option>
                  <option key={4} value={"सध्या घरी"}>सध्या घरी</option>
                  <option key={5} value={"इतर"}>इतर</option>
                </datalist>
              </div>

              <div className="inputgroup">
                <label htmlFor="cjobdetails" className="form-label">कामाविषयी अधिक माहिती</label>
                <input onKeyDown={e => handleEnterKey(e, 24)} ref={ref => (inputRefs.current[24] = ref)} className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} autoComplete='off' id="cjobdetails" name="cjobdetails" value={input.cjobdetails} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="income" className="form-label">वार्षिक उत्पन्न</label>
                <input onKeyDown={e => handleEnterKey(e, 25)} ref={ref => (inputRefs.current[25] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="income" name="income" value={input.income} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="quli" className="form-label">शिक्षण</label>
                <input onKeyDown={e => handleEnterKey(e, 26)} ref={ref => (inputRefs.current[26] = ref)} list='qulilist' autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="quli" name="quli" value={input.quli} onChange={handleChange} ></input>
                <datalist id="qulilist" >
                  <option key={0} value={"अभियांत्रिकी"}>अभियांत्रिकी</option>
                  <option key={1} value={"वैदकीय"}>वैदकीय</option>
                  <option key={2} value={"संगणक"}>संगणक</option>
                  <option key={3} value={"शैक्षणिक"}>शैक्षणिक</option>
                  <option key={4} value={"इतर"}>इतर</option>
                </datalist>
              </div>

              <div className="inputgroup">
                <label htmlFor="qulidetails" className="form-label">डिग्री/शिक्षण प्रकार</label>
                <input onKeyDown={e => handleEnterKey(e, 27)} ref={ref => (inputRefs.current[27] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="qulidetails" name="qulidetails" value={input.qulidetails} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="address" className="form-label">पत्ता</label>
                <input onKeyDown={e => handleEnterKey(e, 28)} ref={ref => (inputRefs.current[28] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="address" name="address" value={input.address} onChange={handleChange} ></input>

              </div>

            </div>
          </div>
        </div>

        <span className="regularboldcolor">ईतर माहिती</span>
        <div className="cardregi">
          <div className='formclass'>
            <div className="rowregi">
              <div className="inputgroup">
                <label htmlFor="navras" className="form-label">नावरस नाव</label>
                <input onKeyDown={e => handleEnterKey(e, 29)} ref={ref => (inputRefs.current[29] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="navras" name="navras" value={input.navras} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="naksh" className="form-label">नक्षत्र</label>
                <input onKeyDown={e => handleEnterKey(e, 30)} ref={ref => (inputRefs.current[30] = ref)} className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} autoComplete='off' id="naksh" name="naksh" value={input.naksh} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="gan" className="form-label">गण</label>
                <input onKeyDown={e => handleEnterKey(e, 31)} ref={ref => (inputRefs.current[31] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="gan" name="gan" value={input.gan} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="nadi" className="form-label">नाडी</label>
                <input onKeyDown={e => handleEnterKey(e, 32)} ref={ref => (inputRefs.current[32] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="nadi" name="nadi" value={input.nadi} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="gotra" className="form-label">गोत्र</label>
                <input onKeyDown={e => handleEnterKey(e, 33)} ref={ref => (inputRefs.current[33] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="gotra" name="gotra" value={input.gotra} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="kdvt" className="form-label">कुलदैवत</label>
                <input onKeyDown={e => handleEnterKey(e, 34)} ref={ref => (inputRefs.current[34] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="kdvt" name="kdvt" value={input.kdvt} onChange={handleChange} ></input>

              </div>

              <div className="inputgroup">
                <label htmlFor="devak" className="form-label">देवक</label>
                <input onKeyDown={e => handleEnterKey(e, 35)} ref={ref => (inputRefs.current[35] = ref)} autoComplete='off' className={newedit === "edit" ? "form-control yellowbackground" : "form-control"} id="devak" name="devak" value={input.devak} onChange={handleChange} ></input>

              </div>

            </div>
          </div>
        </div>


        <span className="regularboldcolor">फोटो माहिती</span>
        <div className="photorow">
          <div className="photoregi">
            <span className="regularboldregi">Photo 1</span>
            <img className='logoregi' name="photo1" id="photo1" src={input.photo1URL || gallary} alt="" onClick={handleImageClick} />
            <input
              type="file"
              ref={fileInputRef1}
              name="photo1in" id="photo1in"
              style={{ display: 'none' }}
              onChange={(event) => handleImageUpload(event, "photo1in")}
            />
          </div>
          <div className="photoregi">
            <span className="regularboldregi">Photo 2</span>
            <img className='logoregi' name="photo2" id="photo2" src={input.photo2URL || gallary} alt="" onClick={handleImageClick} />
            <input
              type="file"
              ref={fileInputRef2}
              style={{ display: 'none' }}
              onChange={(event) => handleImageUpload(event, "photo2in")}
            />
          </div>
          <div className="photoregi">
            <span className="regularboldregi">Photo 3</span>
            <img className='logoregi' name="photo3" id="photo3" src={input.photo3URL || gallary} alt="" onClick={handleImageClick} />
            <input
              type="file"
              ref={fileInputRef3}
              style={{ display: 'none' }}
              onChange={(event) => handleImageUpload(event, "photo3in")}
            />
          </div>
          <div className="photoregi">
            <span className="regularboldregi">Biodata</span>
            <img className='logoregi' name="photo4" id="photo4" src={input.photo4URL || gallary} alt="" onClick={handleImageClick} />
            <input
              type="file"
              ref={fileInputRef4}
              style={{ display: 'none' }}
              onChange={(event) => handleImageUpload(event, "photo4in")}
            />
          </div>

        </div>

        <div className="buttondiv">
          <div onClick={uploadProfile} className="buttonregi">
            <span  className="regularboldregi">{loading ? "Please Wait.." : "UPLOAD PROFILE"}</span>
          </div>
          <div onClick={quit} className="buttonregi">
            <span  className="regularboldregi">Back</span>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default Newregi
